import request from '@/utils/request'

export function getNote(params) {
    return request({
        url: '/blog/index/getTimeAxisPage',
        method: 'get',
        params: params
    })
}
